import { render } from "./ReviewConfirmModal.vue?vue&type=template&id=76b5ab1c&scoped=true"
import script from "./ReviewConfirmModal.vue?vue&type=script&lang=js"
export * from "./ReviewConfirmModal.vue?vue&type=script&lang=js"

import "./ReviewConfirmModal.vue?vue&type=style&index=0&id=76b5ab1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76b5ab1c"]])

export default __exports__